/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: sj
 * @LastEditTime: 2022-05-19 10:36:06
 */
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { List } from '../../../models/page'
import { LimitPageParams } from '../../../services/insurance'
import { ThemeContext } from '../../../theme/ThemeContext'
import { selectInsuranceArray } from '../../tenant/setting/TenentSettingSlice'
import { LimitPriceColumns } from '../Columns'
import {
  getLimitPage,
  LimitPriceValue,
} from '../InsuranceSlice'
import { CurrentQuery } from '../province/CurrentQuery'
import styles from '../province/province.module.css'

export const LimitPrice = () => {

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [data, setData] = useState<List<LimitPriceValue>>()

  const [queries, setQueries] = useState<LimitPageParams>({
    size: 10,
    current: 1,
  })

  useEffect(() => {
    if (insuranceArray && insuranceArray.length !== 0) {
      getData()
    }
  }, [queries, insuranceArray])

  const getData = () => {
    dispatch(
      getLimitPage({
        insuranceCode: insuranceArray[0].insuranceCode,
        ...queries,
        hilistCode: queries.name,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setData(res)
      })
  }

  return (
    <div className={styles.content}>
      <CurrentQuery
        code={1318}
        onValueChange={(vs) => {
          setQueries({ ...queries, ...vs })
        }}
        showNameSearch={false}
      />
      <EditableList
        style={{ color: theme.tc3 }}
        className={styles.table}
        columns={LimitPriceColumns((id) => {
          console.log(id)
        }, queries.size * (queries.current - 1))}
        page={{
          size: queries.size,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        onChangePage={(current, size?: number) => {
          setQueries({
            ...queries,
            current,
            size: size || 10
          })
        }}
      />
    </div>
  )
}
